import {
    Button,
    Col, Form,
    FormCheck,
    FormControl,
    FormGroup,
    FormLabel,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
} from "react-bootstrap";
import React from "react";
import {ProviderSearch} from "../common/ProviderSearch";
import ModalHeader from "react-bootstrap/ModalHeader";
import {GlobalContext} from "../../GlobalContext";
import {OptionalSelect} from "../common/OptionalSelect";
import {GroupSearch} from "../common/GroupSearch";

export default class ReferralUploadProviderPicker extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            prRadio: "existing",
            practiceRadio: "existing",
            provider: {
                id: 0,
                firstName: "",
                lastName: "",
                titleCode: "",
                npi: "",
                specialtyCode: ""
            },
            group: {
                id: 0,
                name: "",
                addr1: "",
                addr2: "",
                city: "",
                state: "",
                zip: "",
                fax: "",
                email: "",
                phone: ""
            },
            titles: [],
            specialties: [],
        };
    }

    componentDidMount() {
        this.context.cachedGet(`/lookup/provider_title`, 300)
            .then(d => this.setState({titles: d.data}));
        this.context.cachedGet(`/lookup/specialty`, 300)
            .then(d => this.setState({specialties: d.data}));
    }

    prRadioChanged = (e) => {
        this.setState({prRadio: e.target.value});
    }

    practiceRadioChanged = (e) => {
        this.setState({practiceRadio: e.target.value});
    }

    providerSelected = (id) => {
        this.context.apiRequest('GET', `/providers/${id}`)
            .then(resp => {
                if (resp && resp.data) {
                    let p = resp.data;
                    this.setState({
                        provider: {
                            id: p.providerId,
                            firstName: p.firstName,
                            lastName: p.lastName,
                            titleCode: p.titleCode,
                            npi: p.npi,
                            specialtyCode: p.specialtyCode
                        },
                        group: p.groups && p.groups.length > 0 ? p.groups[0] : {id: 0, name: ""}
                    })
                }
            });
    }

    providerFieldUpdate = (e) => {
        this.setState({provider: {...this.state.provider, id: 0, [e.target.name]: e.target.value}});
    }

    groupFieldUpdate = (e) => {
        this.setState({group: {...this.state.group, id: 0, [e.target.name]: e.target.value}});
    }

    groupSelected = (id, name) => {
        this.setState({group: {id, name}});
    }

    providerReady = () => {
        const provider = this.state.provider;
        if (this.state.prRadio === 'existing') {
            return !!(provider && provider.id > 0);
        }
        const firstName = (provider.firstName || '').trim();
        const lastName = (provider.lastName || '').trim();
        return firstName.length > 0 && lastName.length > 0;
    };

    ok = () => {
        if (!this.providerReady()) {
            return;
        }
        this.props.onSelect(this.state.provider, this.state.group);
    }

    render() {
        let matches = this.props.matches ? this.props.matches.slice(0, 3) : [];
        let sp = this.props.suggestedProvider || null;
        let sg = this.props.suggestedGroup || null;

        return <Modal show={this.props.show} onHide={this.props.onCancel} size={"lg"}>
            <ModalHeader closeButton>Select/Create {this.props.providerType || "Provider"}</ModalHeader>
            <ModalBody>
                <Row>
                    <Col sm={12}>
                        <Row><Col>
                            <FormCheck label={`Find Existing ${this.props.providerType || "Provider"}`} type={"radio"} value={"existing"} inline name={"prRadio"} checked={this.state.prRadio === "existing"} onChange={this.prRadioChanged}/>
                        </Col></Row>
                        <Row className={"mt-2"}><Col className={"ml-3"}>
                            <ProviderSearch size={"sm"} providerSelected={this.providerSelected} disabled={this.state.prRadio !== "existing"} cleared={this.state.prRadio !== "existing"}/>
                        </Col></Row>
                    </Col>
                </Row>
                <Row className={"mt-4"}>
                    <Col sm={12}>
                        <Row><Col>
                            <FormCheck label={`Create New ${this.props.providerType || "Provider"}`} type={"radio"} value={"create"} inline name={"prRadio"} checked={this.state.prRadio === "create"} onChange={this.prRadioChanged}></FormCheck>
                        </Col></Row>
                        <Row className={"mt-2"}>
                            <FormGroup as={Col} sm={4} className={"ml-3"}>
                                <FormLabel size="sm">First Name</FormLabel>
                                <FormControl size={"sm"} placeholder={"First Name"} name={"firstName"} required onChange={this.providerFieldUpdate} value={this.state.provider.firstName} disabled={this.state.prRadio !== "create"}/>
                            </FormGroup>
                            <FormGroup as={Col} sm={4}>
                                <FormLabel size="sm">Last Name</FormLabel>
                                <FormControl size={"sm"} placeholder={"Last Name"} name={"lastName"} required onChange={this.providerFieldUpdate} value={this.state.provider.lastName} disabled={this.state.prRadio !== "create"}/>
                            </FormGroup>
                            <FormGroup as={Col} sm={2}>
                                <FormLabel size="sm">Title</FormLabel>
                                <OptionalSelect size={"sm"} name={"titleCode"}
                                                disabled={this.state.prRadio !== "create"}
                                                onChange={this.providerFieldUpdate}
                                                options={this.state.titles}
                                                value={this.state.provider.titleCode}
                                                noneLabel={"None"}
                                                canSelectNone={true}
                                                valueKey={"titleCode"} labelKey={"titleCode"}/>
                            </FormGroup>
                        </Row>
                        <Row className={"mt-2"}>
                            <FormGroup as={Col} sm={4} className={"ml-3"}>
                                <FormLabel size="sm">NPI</FormLabel>
                                <FormControl size={"sm"} placeholder={"NPI"} name={"npi"} onChange={this.providerFieldUpdate} value={this.state.provider.npi} disabled={this.state.prRadio !== "create"}/>
                            </FormGroup>
                            <FormGroup as={Col} sm={4}>
                                <Form.Label size="sm">
                                    Specialty
                                </Form.Label>
                                <OptionalSelect name={"specialtyCode"} value={this.state.provider.specialtyCode} options={this.state.specialties} valueKey={"specialtyCode"} labelKey={"specialty"} onChange={this.providerFieldUpdate} noneLabel={"Select a specialty"} disabled={this.state.prRadio !== "create"}/>
                            </FormGroup>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col className={"ml-3"}>
                                <Row>
                                    <Col>
                                        <FormCheck label={"Find Existing Practice"} name={"practiceRadio"} type={"radio"} value={"existing"} inline checked={this.state.practiceRadio === "existing"} onChange={this.practiceRadioChanged} disabled={this.state.prRadio !== "create"}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className={"ml-3"}>
                                        <GroupSearch size={"sm"} groupSelected={this.groupSelected} disabled={this.state.prRadio !== "create"} cleared={this.state.practiceRadio !== "existing"}/>
                                    </Col>
                                </Row>
                                <Row className={"mt-2"}>
                                    <Col>
                                        <FormCheck label={"Create Practice"} name={"practiceRadio"} type={"radio"} value={"create"} inline checked={this.state.practiceRadio === "create"} onChange={this.practiceRadioChanged} disabled={this.state.prRadio !== "create"}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <FormGroup as={Col} sm={6} className={"ml-3"}>
                                        <FormLabel size="sm">Practice Name:</FormLabel>
                                        <FormControl size={"sm"} placeholder={"Name"} name={"name"} onChange={this.groupFieldUpdate} value={this.state.group.id ? "" : this.state.group.name} disabled={this.state.prRadio !== "create" || this.state.practiceRadio !== "create"}/>
                                    </FormGroup>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className={"text-right"}>
                <Button variant="secondary" onClick={this.props.onCancel}>Cancel</Button>
                <Button variant="dark" disabled={!this.providerReady()} onClick={this.ok}>OK</Button>
            </ModalFooter>
        </Modal>
    }
}